import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddressSection from "@Shared/components/sections/address-section.vue";
import MarketingListsContactsChoice from "./marketing-lists-contacts-choice.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import MarketingAddressDisclaimerModal from "@Broker/@Modules/automation/drip-campaign/components/modals/marketing-address-disclaimer-modal.vue";
import { cloneDeep, debounce, isEmpty } from "lodash";
import AutocompleteSection from "@Shared/components/sections/autocomplete-section.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ListDetails",
  components: {
    AddressSection,
    AutocompleteSection,
    MarketingListsContactsChoice,
    MaterialInput,
    MarketingAddressDisclaimerModal
  },
  props: {
    importContacts: {
      type: Boolean,
      default: true
    },
    creating: {
      type: Boolean,
      default: true
    },
    list: {
      type: Object,
      default: () => ({})
    },
    visibility: {
      type: Object,
      default: () => ({
        name: true,
        description: true,
        address: true,
        company: true
      })
    }
  },
  computed: {
    name: {
      get() {
        return this.list.name;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.list), {}, {
          name: value
        }));
      }
    },
    description: {
      get() {
        return this.list.description;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.list), {}, {
          description: value
        }));
      }
    },
    address() {
      return this.list.address;
    },
    companyName() {
      var _this$list$address;
      return ((_this$list$address = this.list.address) == null ? void 0 : _this$list$address.company) || "";
    }
  },
  methods: {
    visibleField(field) {
      return !isEmpty(this.visibility) && this.visibility[field];
    },
    handleCompanyNameChange(value) {
      const list = cloneDeep(this.list);
      list.address.company = value;
      this.$emit("change", list);
    },
    handleAddressChange: debounce(function (value) {
      const list = cloneDeep(this.list);
      const {
        company
      } = list.address;
      list.address = _objectSpread(_objectSpread({}, value), {}, {
        company
      });
      this.$emit("change", list);
    }, 200),
    handleCurrentListChange(list) {
      this.$emit("change", list);
    },
    handleOpenDisclaimerModal() {
      this.$refs.disclaimerModal.showModal();
    }
  }
});